import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { pottstownConfig } from "./data";

export default function PottstownPage() {
  return <CityPageTemplate config={pottstownConfig} />;
}